export const FILTER_NAMES = {
  workflow: 'workflows',
  created_by: 'creators',
  assignee: 'assignees',
}

export const PAGE_SIZE = 20

export const JOB_PRESETS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  FUTURE: 'future',
  COMPLETED: 'completed',
}

export const SORT_OPTIONS = {
  DUE_DATE_ASC: 'end_date_time',
  DUE_DATE_DESC: '-end_date_time',
  START_DATE_ASC: 'start_date_time',
  START_DATE_DESC: '-start_date_time',
  CREATED_DATE_ASC: 'date_created',
  CREATED_DATE_DESC: '-date_created',
  LAST_UPDATED_ASC: 'last_date_updated',
  LAST_UPDATED_DESC: '-last_date_updated',
}
